"use client";

import Link from "next/link";
import { useDemo } from "@/shared/hooks/use-demo";

export function DemoBanner() {
  const { isDemo, personaName } = useDemo();
  if (!isDemo) return null;

  return (
    <div
      role="banner"
      aria-label="Demo mode indicator"
      className="flex h-11 w-full shrink-0 items-center justify-between bg-[#ffd372] px-4"
    >
      <span className="truncate font-winky text-[13px] font-medium text-[#1a1a1a]">
        <span className="hidden sm:inline">
          You&apos;re exploring HOKU with {personaName}&apos;s wardrobe
        </span>
        <span className="sm:hidden">{personaName}&apos;s wardrobe ✨</span>
      </span>
      <Link
        href="/login?action=signup"
        className="ml-3 shrink-0 rounded-none border-2 border-[#1a1a1a] bg-[#1a1a1a] px-3 py-1 font-winky text-[12px] font-semibold text-[#ffd372] shadow-[2px_2px_0px_#ffd372] transition-all active:translate-x-[1px] active:translate-y-[1px] active:shadow-none"
      >
        Sign Up Free →
      </Link>
    </div>
  );
}
